<template>
  <default-modal
    ref="box"
    :title="title"
    :modalWidth="600"
    :confirmTxt="confirmText"
    @confirm="confirm"
  >
    <div class="modal-body">
      <div class="row">
        <img
          src="@/assets/img/icon/u1280.svg"
          alt=""
        />
        是否停用任务“<span v-text="taskName"></span>” ?
      </div>
    </div>
  </default-modal>
</template>
<script>
import DefaultModal from "_c/modals/defaultModal";
import { disableOrenable } from "@/requests/threeTierMission";
export default {
  components: {
    DefaultModal,
  },
  data() {
    return {
      taskId: "",
      taskName: "",
      title: "停用任务",
      confirmText: "",
      successFn: "",
      type: 0,
    };
  },
  mounted() {
    window.$modal.tasksStatus = {};
    window.$modal.tasksStatus.show = (id, taskName, type) => {
      this.taskId = id;
      this.taskName = taskName;
      this.type = type;
      this.confirmText = "确定";
      return new Promise((resolve) => {
        this.init(() => {
          resolve(true);
        });
      });
    };
    //监听键盘按键事件
    let self = this;
    this.$nextTick(function () {
      document.addEventListener('keyup', function (e) {
        //此处填写你的业务逻辑即可
        if (e.keyCode == 27) {
          self.$refs.box.hide();
        }
      })
    })
  },
  methods: {
    // 初始化信息
    init(fn) {
      this.$refs.box.show();
      this.successFn = fn;
    },
    async confirm() {
      let resValue = await disableOrenable({
        taskId: this.taskId,
        type: this.type,
      });
      if (resValue.code == 200) {
        this.$refs.box.hide();
        this.successFn();
      } else {
        this.$refs.box.setWrong(resValue.msg);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-body {
  padding: 10px 0 10px 50px;
  text-align: left;
  .row {
    height: 30px;
    line-height: 30px;
    img {
      position: relative;
      top: 5px;
      margin-right: 8px;
    }
  }
}
</style>
